export const parseDDMMYYYY = (dateStr: string): Date => {
  const [dd, MM, yyyy] = dateStr.split("-");
  return new Date(Number(yyyy), Number(MM) - 1, Number(dd));
}